import React, { useState } from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import { getTrancheBotData } from "../../service/api";
import "./TrancheSearch.css";
import TrancheForm from "./TrancheForm";
import { ButtonLoader } from "../ButtonLoader";
const TrancheSearch = ({ fetchAllTranches }) => {
  const [opportunityId, setOpportunityId] = useState("");
  const [error, setError] = useState("");
  const [trancheData, setTrancheData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!opportunityId) {
      setError("Opportunity ID is required");
      return;
    }
    if (!/^\d+$/.test(opportunityId)) {
      setError(" Please Enter a Valid Opportunity ID ");
      return;
    }
    try {
      setLoading(true);
      const response = await getTrancheBotData(opportunityId);
      setTrancheData(response.data.data);
      setError("");
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      setError(errorMessage);
      setTrancheData(null);
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setOpportunityId(value);
    if (!value || /^\d+$/.test(value)) {
      setError("");
    }
    setTrancheData(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  return (
    <Card className="p-3 mb-3 tranche-form-card">
      <Card.Title column sm={12} className="form-label">
        Opportunity ID
      </Card.Title>
      <Form onSubmit={handleSubmit}>
        <Form.Group as={Row} className="mb-3">
          <Col sm={10}>
            <Form.Control
              type="text"
              value={opportunityId}
              onChange={handleInputChange}
              isInvalid={!!error}
              placeholder="Enter Opportunity ID"
              className="form-input"
              disabled={loading}
            />
            <Form.Control.Feedback type="invalid" className="form-feedback">
              {error}
            </Form.Control.Feedback>
          </Col>
          <Col sm={2} className="next-button">
            <Button
              type="submit"
              disabled={!opportunityId || loading || trancheData}
            >
              {loading ? <ButtonLoader show={true} /> : "Next"}
            </Button>
          </Col>
        </Form.Group>
      </Form>

      {trancheData && (
        <TrancheForm
          fetchedData={trancheData}
          setTrancheData={setTrancheData}
          setOpportunityId={setOpportunityId}
          fetchAllTranches={fetchAllTranches}
          opportunityId={opportunityId}
        />
      )}
    </Card>
  );
};

export default TrancheSearch;
